import React from 'react';

const CourseList = () => {
  return <div>CourseList</div>;
};

export default CourseList;
